/* eslint-disable react-hooks/rules-of-hooks */
import 'react-app-polyfill/stable'
import 'core-js'
import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'
import * as serviceWorker from './serviceWorker'
import { Provider } from 'react-redux'
import store from './store'

import LocalStorageService from './services/LocalStorageService'

const cmia_data = LocalStorageService.obterItem('_pmpv-cmia')

let mainStore = store

if (cmia_data) {
  mainStore = {
    ...mainStore,
    user: cmia_data.user,
    jwt: cmia_data.jwt,
    theme: cmia_data.theme,
  }
}

ReactDOM.render(
  <Provider store={mainStore}>
    <App />
  </Provider>,
  document.getElementById('root'),
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister()
